
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restplasser",
      function () {
        return require("private-next-pages/restplasser/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restplasser"])
      });
    }
  